import { ShieldCheck, Zap, Battery, AlertCircle, HardDrive, Cpu, Activity, FileText, UserCheck, Shield } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useDiagnosticContext } from '../context/DiagnosticContext';
import styles from './ProHeroCard.module.css';

export const ProHeroCard = () => {
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const { resetDiagnostic } = useDiagnosticContext();

  const handleProClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!user) {
      navigate('/login', { state: { from: window.location.pathname } });
      return;
    }
    if (!profile || profile.credits <= 0) {
      navigate('/pricing');
      return;
    }
    resetDiagnostic();
    navigate('/diagnostic');
  };


  const features = [
    { icon: <Activity size={16} />, text: "80+ System Health Checks" },
    { icon: <Zap size={16} />, text: "AI-Powered Root Cause Analysis" },
    { icon: <Shield size={16} />, text: "Driver & Hardware Conflict Scan" },
    { icon: <AlertCircle size={16} />, text: "BSOD + Minidump Log Parsing" },
    { icon: <Battery size={16} />, text: "Advanced Battery Lifecycle Analysis" },
    { icon: <HardDrive size={16} />, text: "Disk S.M.A.R.T. Predictive Health" },
    { icon: <Cpu size={16} />, text: "Startup & Bloatware Optimization" },
    { icon: <FileText size={16} />, text: "Office / Excel Crash Detection" },
    { icon: <UserCheck size={16} />, text: "Manufacturer-Specific Fix Guides" },
    { icon: <FileText size={16} />, text: "Technician-Ready PDF Summary" }
  ];

  return (
    <div className={styles.heroCard}>
      <div className={styles.premiumGlow}></div>
      <div className={styles.cardInner}>
        <div className={styles.content}>
          <div className={styles.badge}>PREMIUM DIAGNOSTIC ENGINE</div>
          <div className={styles.header}>
            <div className={styles.iconBox}>
              <ShieldCheck size={32} />
            </div>
            <div className={styles.titleArea}>
              <h2>Full AI Health Check <span>PRO</span></h2>
              <p>The complete PC diagnostic suite with NVIDIA-powered AI root cause analysis.</p>
            </div>
          </div>

          <div className={styles.featuresGrid}>
            {features.map((f, i) => (
              <div key={i} className={styles.featureItem}>
                <span className={styles.featureIcon}>{f.icon}</span>
                <span className={styles.featureText}>{f.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.pricingSidebar}>
          {user && profile && profile.credits > 0 ? (
            <>
              <div className={styles.pricingTitle}>Ready to Scan</div>
              <div className={styles.creditStatus}>
                <div className={styles.creditCount}>
                  <span>You have</span>
                  <strong>{profile.credits} report credits</strong>
                  <span>remaining</span>
                </div>
              </div>
              <div className={styles.actions}>
                <button className="btn btn-primary w-full" onClick={handleProClick}>
                  Run Full AI Diagnostic →
                </button>
                <button className="btn btn-secondary w-full" onClick={() => navigate('/pricing')} style={{ marginTop: '12px' }}>
                  Buy more credits
                </button>
                <p className={styles.creditNote}>Pro report uses 1 credit.</p>
              </div>
            </>
          ) : (
            <>
              <div className={styles.pricingTitle}>
                {user && profile && profile.credits === 0 ? "No credits remaining" : "Get Pro Access"}
              </div>
              
              <div style={{ color: 'var(--text-2)', fontSize: '14px', marginBottom: '20px', lineHeight: '1.5' }}>
                Unlock all 80+ advanced checks, NVIDIA AI root cause diagnostics, and custom manual fix guides.
              </div>

              <div style={{ background: 'rgba(255, 255, 255, 0.02)', padding: '16px', borderRadius: 'var(--radius)', border: '1px solid var(--border)', marginBottom: '24px' }}>
                <div style={{ fontWeight: 600, color: 'var(--text-0)', marginBottom: '6px', fontSize: '13px' }}>One-time payment:</div>
                <div style={{ color: '#fbbf24', fontWeight: 700, fontSize: '20px' }}>£4.99 / PC</div>
                <div style={{ fontSize: '12px', color: 'var(--text-2)', marginTop: '4px' }}>Family Pack available for £9.99</div>
              </div>
              
              <div className={styles.actions}>
                <button className="btn btn-primary w-full" onClick={handleProClick}>
                  {!user ? 'Sign in to start →' : 'Buy Report Credits →'}
                </button>
                <p className={styles.creditNote}>Pro report uses 1 credit.</p>
                <p className={styles.secureText}>
                  <ShieldCheck size={12} /> Secure Stripe Payment
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
